var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 115,
    viewBox: "0 0 114 115",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0034 47.4016C59.0545 37.7074 47.6681 31.4517 35.1977 29.9276C22.7274 28.4035 10.1265 31.7275 1.64877e-05 39.2126L61.8836 114.722C71.2143 106.261 76.9491 94.5551 77.902 82.025C78.8549 69.4948 74.953 57.0992 67.0034 47.4016Z",
    fill: "#543EE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.966 18.7478C94.0224 9.05195 82.6391 2.79371 70.1708 1.26733C57.7024 -0.259043 45.1028 3.06321 34.9775 10.547L96.8611 86.0569C106.186 77.5943 111.916 65.8895 112.866 53.3622C113.817 40.8349 109.914 28.4429 101.966 18.7478Z",
    fill: "#FFB147"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape1.81ed95d551df75c30b7190552a826b5a.svg";
export { ForwardRef as ReactComponent };